export default {"src":"https://s.sylndr.com/c-c51c782/_next/static/media/check.048936ba.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};